import "./EachDecision.css";

export const EachDecision = ({
  idAsNumber,
  selectedIndicator,
  isAlreadyAnsweredBorder,
  url,
  indicator,
  handleClick,
  isYesterdayAnswerModalOpen,
}) => {
  let styles = null;
  if (localStorage.playedIds) {
    const ids = JSON.parse(localStorage.playedIds);
    const exist = ids.find((i) => i.id === idAsNumber);
    if (!exist && isAlreadyAnsweredBorder && selectedIndicator === indicator) {
      styles = { border: "5px solid #f4e377" };
    } else {
      JSON.parse(localStorage.playedIds).forEach((element) => {
        if (element.id === idAsNumber) {
          if (
            element.selectedValue === window.correctAnswer &&
            element.selectedValue === indicator
          ) {
            styles = { border: "5px solid #68a870" };
          } else if (
            element.selectedValue !== window.correctAnswer &&
            element.selectedValue === indicator
          ) {
            styles = { border: "5px solid #d63a38" };
          } else if (window.correctAnswer === indicator) {
            styles = { border: "5px solid #68a870" };
          }
        }
      });
    }
  } else {
    if (isAlreadyAnsweredBorder && selectedIndicator === indicator) {
      styles = { border: "5px solid #f4e377" };
    }
  }

  return (
    <div
      className="each-decision flex flex-col justify-center items-center relative"
      onClick={() =>
        !isYesterdayAnswerModalOpen ? handleClick(indicator) : null
      }
    >
      {window.correctAnswer === indicator && isYesterdayAnswerModalOpen ? (
        <div className="flex" style={{ border: "5px solid #68a870" }}>
          <img src={url} alt="indicator" />
        </div>
      ) : (
        <div className="flex" style={styles}>
          <img src={url} alt="indicator" />
        </div>
      )}

      <p className="text-xl md:text-3xl" style={{ fontFamily: "Union" }}>
        {indicator}
      </p>
    </div>
  );
};
